// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'http://localhost:5001' | (string & {});
};

/**
 * AcademiesResponseModel
 */
export type AcademiesResponseModel = Array<string>;

/**
 * AdageBaseModel
 */
export type AdageBaseModel = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
};

/**
 * AdageFrontRoles
 */
export enum AdageFrontRoles {
    REDACTOR = 'redactor',
    READONLY = 'readonly'
}

/**
 * AdageHeaderLink
 */
export enum AdageHeaderLink {
    SEARCH = 'search',
    MY_INSTITUTION_OFFERS = 'my_institution_offers',
    ADAGE_LINK = 'adage_link',
    MY_FAVORITES = 'my_favorites',
    DISCOVERY = 'discovery'
}

/**
 * AdageHeaderLogBody
 */
export type AdageHeaderLogBody = {
    header_link_name: AdageHeaderLink;
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
};

/**
 * AdagePlaylistType
 */
export enum AdagePlaylistType {
    OFFER = 'offer',
    VENUE = 'venue',
    DOMAIN = 'domain'
}

/**
 * AuthenticatedResponse
 */
export type AuthenticatedResponse = {
    /**
     * Canprebook
     */
    canPrebook: boolean | null;
    /**
     * Departmentcode
     */
    departmentCode: string | null;
    /**
     * Email
     */
    email: string | null;
    /**
     * Favoritescount
     */
    favoritesCount: number;
    /**
     * Institutioncity
     */
    institutionCity: string | null;
    /**
     * Institutionname
     */
    institutionName: string | null;
    institutionRuralLevel: InstitutionRuralLevel | null;
    /**
     * Lat
     */
    lat: number | null;
    /**
     * Lon
     */
    lon: number | null;
    /**
     * Offerscount
     */
    offersCount: number;
    preferences: RedactorPreferences | null;
    /**
     * Programs
     */
    programs: Array<EducationalInstitutionProgramModel>;
    role: AdageFrontRoles;
    /**
     * Uai
     */
    uai: string | null;
};

/**
 * BookCollectiveOfferRequest
 */
export type BookCollectiveOfferRequest = {
    /**
     * Stockid
     */
    stockId: number;
};

/**
 * BookCollectiveOfferResponse
 */
export type BookCollectiveOfferResponse = {
    /**
     * Bookingid
     */
    bookingId: number;
};

/**
 * CatalogViewBody
 */
export type CatalogViewBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Source
     */
    source: string;
};

/**
 * CollectiveAdditionalFeeResponse
 */
export type CollectiveAdditionalFeeResponse = {
    /**
     * Amount
     */
    amount: number;
    /**
     * Label
     */
    label: string | null;
    type: CollectiveAdditionalFeeType;
};

/**
 * CollectiveAdditionalFeeType
 */
export enum CollectiveAdditionalFeeType {
    ACCOMMODATION = 'ACCOMMODATION',
    TRAVEL = 'TRAVEL',
    MEAL = 'MEAL',
    CONSUMABLE_ITEMS = 'CONSUMABLE_ITEMS',
    COPYRIGHT = 'COPYRIGHT',
    BROADCASTING = 'BROADCASTING',
    APPLICATION_FEE = 'APPLICATION_FEE',
    MANAGEMENT_FEE = 'MANAGEMENT_FEE',
    OTHER = 'OTHER'
}

/**
 * CollectiveLocationType
 */
export enum CollectiveLocationType {
    SCHOOL = 'SCHOOL',
    ADDRESS = 'ADDRESS',
    TO_BE_DEFINED = 'TO_BE_DEFINED'
}

/**
 * CollectiveOfferDatesModel
 */
export type CollectiveOfferDatesModel = {
    /**
     * End
     */
    end: string;
    /**
     * Start
     */
    start: string;
};

/**
 * CollectiveOfferResponseModel
 */
export type CollectiveOfferResponseModel = {
    /**
     * Additionaldetails
     */
    additionalDetails: string | null;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant: boolean | null;
    /**
     * Contactemail
     */
    contactEmail: string | null;
    /**
     * Contactphone
     */
    contactPhone: string | null;
    /**
     * Description
     */
    description: string;
    /**
     * Domains
     */
    domains: Array<OfferDomain>;
    /**
     * Durationminutes
     */
    durationMinutes: number | null;
    educationalInstitution: EducationalInstitutionResponseModel | null;
    /**
     * Educationalpricedetail
     */
    educationalPriceDetail?: string | null;
    /**
     * Formats
     */
    formats: Array<EacFormat>;
    /**
     * Id
     */
    id: number;
    /**
     * Imagealternativetext
     */
    imageAlternativeText: string | null;
    /**
     * Imagecredit
     */
    imageCredit: string | null;
    /**
     * Imageurl
     */
    imageUrl: string | null;
    /**
     * Interventionarea
     */
    interventionArea: Array<string>;
    /**
     * Istemplate
     */
    isTemplate: boolean;
    location: GetCollectiveOfferLocationModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant: boolean | null;
    /**
     * Name
     */
    name: string;
    nationalProgram: NationalProgramResponseModel | null;
    stock: OfferStockResponse;
    /**
     * Students
     */
    students: Array<StudentLevels>;
    teacher: EducationalRedactorResponseModel | null;
    venue: OfferVenueResponse;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant: boolean | null;
};

/**
 * CollectiveOfferTemplateResponseModel
 */
export type CollectiveOfferTemplateResponseModel = {
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant: boolean | null;
    /**
     * Contactemail
     */
    contactEmail: string | null;
    contactForm?: OfferContactFormEnum | null;
    /**
     * Contactphone
     */
    contactPhone: string | null;
    /**
     * Contacturl
     */
    contactUrl?: string | null;
    dates?: CollectiveOfferDatesModel | null;
    /**
     * Description
     */
    description: string;
    /**
     * Domains
     */
    domains: Array<OfferDomain>;
    /**
     * Durationminutes
     */
    durationMinutes: number | null;
    /**
     * Educationalpricedetail
     */
    educationalPriceDetail?: string | null;
    /**
     * Formats
     */
    formats: Array<EacFormat>;
    /**
     * Id
     */
    id: number;
    /**
     * Imagealternativetext
     */
    imageAlternativeText: string | null;
    /**
     * Imagecredit
     */
    imageCredit: string | null;
    /**
     * Imageurl
     */
    imageUrl: string | null;
    /**
     * Interventionarea
     */
    interventionArea: Array<string>;
    /**
     * Isfavorite
     */
    isFavorite?: boolean | null;
    /**
     * Istemplate
     */
    isTemplate: boolean;
    location: GetCollectiveOfferLocationModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant: boolean | null;
    /**
     * Name
     */
    name: string;
    nationalProgram: NationalProgramResponseModel | null;
    /**
     * Students
     */
    students: Array<StudentLevels>;
    venue: OfferVenueResponse;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant: boolean | null;
};

/**
 * CollectiveRequestBody
 */
export type CollectiveRequestBody = {
    /**
     * Collectiveoffertemplateid
     */
    collectiveOfferTemplateId: number;
    /**
     * Comment
     */
    comment: string;
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Phonenumber
     */
    phoneNumber?: string | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Requesteddate
     */
    requestedDate?: string | null;
    /**
     * Totalstudents
     */
    totalStudents?: number | null;
    /**
     * Totalteachers
     */
    totalTeachers?: number | null;
};

/**
 * CollectiveRequestResponseModel
 */
export type CollectiveRequestResponseModel = {
    /**
     * Id
     */
    id: number;
};

/**
 * ConsultOfferBody
 */
export type ConsultOfferBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Playlistid
     */
    playlistId?: number | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Source
     */
    source?: string | null;
};

/**
 * EacFormat
 */
export enum EacFormat {
    ATELIER_DE_PRATIQUE = 'Atelier de pratique',
    CONCERT = 'Concert',
    CONF_RENCE_RENCONTRE = 'Conférence, rencontre',
    FESTIVAL_SALON_CONGR_S = 'Festival, salon, congrès',
    PROJECTION_AUDIOVISUELLE = 'Projection audiovisuelle',
    REPR_SENTATION = 'Représentation',
    VISITE_GUID_E = 'Visite guidée',
    VISITE_LIBRE = 'Visite libre'
}

/**
 * EducationalInstitutionBudgetResponseModel
 */
export type EducationalInstitutionBudgetResponseModel = {
    /**
     * Budget
     */
    budget: number;
};

/**
 * EducationalInstitutionProgramModel
 */
export type EducationalInstitutionProgramModel = {
    /**
     * Description
     */
    description: string | null;
    /**
     * Label
     */
    label: string | null;
    /**
     * Name
     */
    name: string;
};

/**
 * EducationalInstitutionResponseModel
 */
export type EducationalInstitutionResponseModel = {
    /**
     * City
     */
    city: string;
    /**
     * Id
     */
    id: number;
    /**
     * Institutiontype
     */
    institutionType: string;
    /**
     * Name
     */
    name: string;
    /**
     * Postalcode
     */
    postalCode: string;
};

/**
 * EducationalRedactorResponseModel
 */
export type EducationalRedactorResponseModel = {
    /**
     * Civility
     */
    civility: string | null;
    /**
     * Email
     */
    email: string;
    /**
     * Firstname
     */
    firstName: string | null;
    /**
     * Lastname
     */
    lastName: string | null;
};

/**
 * FavoritesResponseModel
 */
export type FavoritesResponseModel = {
    /**
     * Favoritestemplate
     */
    favoritesTemplate: Array<CollectiveOfferTemplateResponseModel>;
};

/**
 * GetCollectiveOfferLocationModel
 */
export type GetCollectiveOfferLocationModel = {
    location: LocationResponseModelV2 | null;
    /**
     * Locationcomment
     */
    locationComment: string | null;
    locationType: CollectiveLocationType;
};

/**
 * GetRelativeVenuesQueryModel
 */
export type GetRelativeVenuesQueryModel = {
    /**
     * Getrelative
     */
    getRelative?: boolean;
};

/**
 * GetTemplateIdsModel
 */
export type GetTemplateIdsModel = {
    /**
     * Ids
     */
    ids: Array<number>;
};

/**
 * InstitutionRuralLevel
 */
export enum InstitutionRuralLevel {
    GRANDS_CENTRES_URBAINS = 'Grands centres urbains',
    CEINTURES_URBAINES = 'Ceintures urbaines',
    CENTRES_URBAINS_INTERM_DIAIRES = 'Centres urbains intermédiaires',
    PETITES_VILLES = 'Petites villes',
    BOURGS_RURAUX = 'Bourgs ruraux',
    RURAL_HABITAT_DISPERS_ = 'Rural à habitat dispersé',
    RURAL_HABITAT_TR_S_DISPERS_ = 'Rural à habitat très dispersé'
}

/**
 * ListCollectiveOfferTemplateResponseModel
 */
export type ListCollectiveOfferTemplateResponseModel = {
    /**
     * Collectiveoffers
     */
    collectiveOffers: Array<CollectiveOfferTemplateResponseModel>;
};

/**
 * ListCollectiveOffersResponseModel
 */
export type ListCollectiveOffersResponseModel = {
    /**
     * Collectiveoffers
     */
    collectiveOffers: Array<CollectiveOfferResponseModel>;
};

/**
 * LocalOfferersPlaylist
 */
export type LocalOfferersPlaylist = {
    /**
     * Venues
     */
    venues: Array<LocalOfferersPlaylistOffer>;
};

/**
 * LocalOfferersPlaylistOffer
 */
export type LocalOfferersPlaylistOffer = {
    /**
     * City
     */
    city: string | null;
    /**
     * Distance
     */
    distance: number | null;
    /**
     * Id
     */
    id: number;
    /**
     * Imgalternativetext
     */
    imgAlternativeText: string | null;
    /**
     * Imgurl
     */
    imgUrl: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Publicname
     */
    publicName: string;
};

/**
 * LocationResponseModelV2
 */
export type LocationResponseModelV2 = {
    /**
     * Banid
     */
    banId: string | null;
    /**
     * City
     */
    city: string;
    /**
     * Departmentcode
     */
    departmentCode: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Inseecode
     */
    inseeCode: string | null;
    /**
     * Ismanualedition
     */
    isManualEdition: boolean;
    /**
     * Isvenuelocation
     */
    isVenueLocation: boolean;
    /**
     * Label
     */
    label: string | null;
    /**
     * Latitude
     */
    latitude: number;
    /**
     * Longitude
     */
    longitude: number;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Street
     */
    street: string | null;
};

/**
 * NationalProgramResponseModel
 */
export type NationalProgramResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * OfferBody
 */
export type OfferBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Playlistid
     */
    playlistId?: number | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Vuetype
     */
    vueType?: string | null;
};

/**
 * OfferContactFormEnum
 */
export enum OfferContactFormEnum {
    FORM = 'form'
}

/**
 * OfferDomain
 */
export type OfferDomain = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * OfferFavoriteBody
 */
export type OfferFavoriteBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfavorite
     */
    isFavorite: boolean;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Playlistid
     */
    playlistId?: number | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Vuetype
     */
    vueType?: string | null;
};

/**
 * OfferIdBody
 */
export type OfferIdBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Vuetype
     */
    vueType?: string | null;
};

/**
 * OfferListSwitch
 */
export type OfferListSwitch = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Ismobile
     */
    isMobile?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Source
     */
    source: string;
};

/**
 * OfferManagingOffererResponse
 */
export type OfferManagingOffererResponse = {
    /**
     * Name
     */
    name: string;
};

/**
 * OfferStockResponse
 */
export type OfferStockResponse = {
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime?: string | null;
    /**
     * Collectiveadditionalfees
     */
    collectiveAdditionalFees: Array<CollectiveAdditionalFeeResponse>;
    /**
     * Educationalpricedetail
     */
    educationalPriceDetail?: string | null;
    /**
     * Enddatetime
     */
    endDatetime?: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Numberofteachers
     */
    numberOfTeachers: number;
    /**
     * Numberoftickets
     */
    numberOfTickets: number;
    /**
     * Price
     */
    price: number;
    /**
     * Serviceprice
     */
    servicePrice: number;
    /**
     * Startdatetime
     */
    startDatetime?: string | null;
};

/**
 * OfferVenueCoordinates
 */
export type OfferVenueCoordinates = {
    /**
     * Latitude
     */
    latitude: number;
    /**
     * Longitude
     */
    longitude: number;
};

/**
 * OfferVenueResponse
 */
export type OfferVenueResponse = {
    /**
     * Adageid
     */
    adageId: string | null;
    /**
     * Address
     */
    address: string;
    /**
     * City
     */
    city: string;
    coordinates: OfferVenueCoordinates;
    /**
     * Departmentcode
     */
    departmentCode: string;
    /**
     * Id
     */
    id: number;
    /**
     * Imgalternativetext
     */
    imgAlternativeText: string | null;
    /**
     * Imgurl
     */
    imgUrl: string | null;
    managingOfferer: OfferManagingOffererResponse;
    /**
     * Name
     */
    name: string;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Publicname
     */
    publicName: string;
};

/**
 * PaginationType
 */
export enum PaginationType {
    NEXT = 'next',
    PREVIOUS = 'previous'
}

/**
 * PlaylistBody
 */
export type PlaylistBody = {
    /**
     * Domainid
     */
    domainId?: number | null;
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Index
     */
    index?: number | null;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Numberoftiles
     */
    numberOfTiles?: number | null;
    /**
     * Offerid
     */
    offerId?: number | null;
    /**
     * Playlistid
     */
    playlistId: number;
    playlistType: AdagePlaylistType;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Venueid
     */
    venueId?: number | null;
};

/**
 * PostCollectiveRequestBodyModel
 */
export type PostCollectiveRequestBodyModel = {
    /**
     * Comment
     */
    comment: string;
    /**
     * Phonenumber
     */
    phoneNumber: string | null;
    /**
     * Requesteddate
     */
    requestedDate: string | null;
    /**
     * Totalstudents
     */
    totalStudents: number | null;
    /**
     * Totalteachers
     */
    totalTeachers: number | null;
};

/**
 * RedactorPreferences
 */
export type RedactorPreferences = {
    /**
     * Broadcast Help Closed
     */
    broadcast_help_closed?: boolean | null;
    /**
     * Feedback Form Closed
     */
    feedback_form_closed?: boolean | null;
};

/**
 * SearchBody
 */
export type SearchBody = {
    /**
     * Filters
     */
    filters: Array<string>;
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Resultscount
     */
    resultsCount: number;
};

/**
 * StockIdBody
 */
export type StockIdBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Stockid
     */
    stockId: number;
    /**
     * Vuetype
     */
    vueType?: string | null;
};

/**
 * StudentLevels
 */
export enum StudentLevels {
    _COLES_MARSEILLE_MATERNELLE = 'Écoles Marseille - Maternelle',
    _COLES_MARSEILLE_CP_CE1_CE2 = 'Écoles Marseille - CP, CE1, CE2',
    _COLES_MARSEILLE_CM1_CM2 = 'Écoles Marseille - CM1, CM2',
    COLL_GE_6E = 'Collège - 6e',
    COLL_GE_5E = 'Collège - 5e',
    COLL_GE_4E = 'Collège - 4e',
    COLL_GE_3E = 'Collège - 3e',
    LYC_E_SECONDE = 'Lycée - Seconde',
    LYC_E_PREMI_RE = 'Lycée - Première',
    LYC_E_TERMINALE = 'Lycée - Terminale',
    CAP_2E_ANN_E = 'CAP - 2e année',
    CAP_1RE_ANN_E = 'CAP - 1re année'
}

/**
 * SuggestionType
 */
export enum SuggestionType {
    VENUE = 'venue',
    OFFER_CATEGORY = 'offer category',
    OFFER = 'offer'
}

/**
 * TrackingAutocompleteSuggestionBody
 */
export type TrackingAutocompleteSuggestionBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    suggestionType: SuggestionType;
    /**
     * Suggestionvalue
     */
    suggestionValue: string;
};

/**
 * TrackingCTAShareBody
 */
export type TrackingCTAShareBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Source
     */
    source: string;
    /**
     * Vuetype
     */
    vueType?: string | null;
};

/**
 * TrackingFilterBody
 */
export type TrackingFilterBody = {
    /**
     * Filtervalues
     */
    filterValues: {
        [key: string]: unknown;
    };
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Resultnumber
     */
    resultNumber: number;
};

/**
 * TrackingShowMoreBody
 */
export type TrackingShowMoreBody = {
    /**
     * Iframefrom
     */
    iframeFrom: string;
    /**
     * Isfromnoresult
     */
    isFromNoResult?: boolean | null;
    /**
     * Queryid
     */
    queryId?: string | null;
    /**
     * Source
     */
    source: string;
    type: PaginationType;
};

/**
 * ValidationError
 *
 * Model of a validation error response.
 */
export type ValidationError = Array<ValidationErrorElement>;

/**
 * ValidationErrorElement
 *
 * Model of a validation error response element.
 */
export type ValidationErrorElement = {
    /**
     * Error context
     */
    ctx?: {
        [key: string]: unknown;
    };
    /**
     * Missing field name
     */
    loc: Array<string>;
    /**
     * Error message
     */
    msg: string;
    /**
     * Error type
     */
    type: string;
};

/**
 * VenueResponse
 */
export type VenueResponse = {
    /**
     * Adageid
     */
    adageId: string | null;
    /**
     * Departementcode
     */
    departementCode: string;
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Publicname
     */
    publicName: string;
    /**
     * Relative
     */
    relative: Array<number>;
};

export type getAdageIframeAuthenticateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/authenticate';
};

export type getAdageIframeAuthenticateErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeAuthenticateError = getAdageIframeAuthenticateErrors[keyof getAdageIframeAuthenticateErrors];

export type getAdageIframeAuthenticateResponses = {
    /**
     * OK
     */
    200: AuthenticatedResponse;
};

export type getAdageIframeAuthenticateResponse = getAdageIframeAuthenticateResponses[keyof getAdageIframeAuthenticateResponses];

export type getAdageIframeCollectiveAcademiesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/collective/academies';
};

export type getAdageIframeCollectiveAcademiesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeCollectiveAcademiesError = getAdageIframeCollectiveAcademiesErrors[keyof getAdageIframeCollectiveAcademiesErrors];

export type getAdageIframeCollectiveAcademiesResponses = {
    /**
     * OK
     */
    200: AcademiesResponseModel;
};

export type getAdageIframeCollectiveAcademiesResponse = getAdageIframeCollectiveAcademiesResponses[keyof getAdageIframeCollectiveAcademiesResponses];

export type postAdageIframeCollectiveBookingsData = {
    body: BookCollectiveOfferRequest;
    path?: never;
    query?: never;
    url: '/adage-iframe/collective/bookings';
};

export type postAdageIframeCollectiveBookingsErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeCollectiveBookingsError = postAdageIframeCollectiveBookingsErrors[keyof postAdageIframeCollectiveBookingsErrors];

export type postAdageIframeCollectiveBookingsResponses = {
    /**
     * OK
     */
    200: BookCollectiveOfferResponse;
};

export type postAdageIframeCollectiveBookingsResponse = postAdageIframeCollectiveBookingsResponses[keyof postAdageIframeCollectiveBookingsResponses];

export type getAdageIframeCollectiveFavoritesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/collective/favorites';
};

export type getAdageIframeCollectiveFavoritesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeCollectiveFavoritesError = getAdageIframeCollectiveFavoritesErrors[keyof getAdageIframeCollectiveFavoritesErrors];

export type getAdageIframeCollectiveFavoritesResponses = {
    /**
     * OK
     */
    200: FavoritesResponseModel;
};

export type getAdageIframeCollectiveFavoritesResponse = getAdageIframeCollectiveFavoritesResponses[keyof getAdageIframeCollectiveFavoritesResponses];

export type getAdageIframeCollectiveInstitutionData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/collective/institution';
};

export type getAdageIframeCollectiveInstitutionErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeCollectiveInstitutionError = getAdageIframeCollectiveInstitutionErrors[keyof getAdageIframeCollectiveInstitutionErrors];

export type getAdageIframeCollectiveInstitutionResponses = {
    /**
     * OK
     */
    200: EducationalInstitutionBudgetResponseModel;
};

export type getAdageIframeCollectiveInstitutionResponse = getAdageIframeCollectiveInstitutionResponses[keyof getAdageIframeCollectiveInstitutionResponses];

export type getAdageIframeCollectiveOffersTemplateData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Ids
         */
        ids: Array<number>;
    };
    url: '/adage-iframe/collective/offers-template/';
};

export type getAdageIframeCollectiveOffersTemplateErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeCollectiveOffersTemplateError = getAdageIframeCollectiveOffersTemplateErrors[keyof getAdageIframeCollectiveOffersTemplateErrors];

export type getAdageIframeCollectiveOffersTemplateResponses = {
    /**
     * OK
     */
    200: ListCollectiveOfferTemplateResponseModel;
};

export type getAdageIframeCollectiveOffersTemplateResponse = getAdageIframeCollectiveOffersTemplateResponses[keyof getAdageIframeCollectiveOffersTemplateResponses];

export type getAdageIframeCollectiveOffersTemplateByOfferIdData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/adage-iframe/collective/offers-template/{offer_id}';
};

export type getAdageIframeCollectiveOffersTemplateByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeCollectiveOffersTemplateByOfferIdError = getAdageIframeCollectiveOffersTemplateByOfferIdErrors[keyof getAdageIframeCollectiveOffersTemplateByOfferIdErrors];

export type getAdageIframeCollectiveOffersTemplateByOfferIdResponses = {
    /**
     * OK
     */
    200: CollectiveOfferTemplateResponseModel;
};

export type getAdageIframeCollectiveOffersTemplateByOfferIdResponse = getAdageIframeCollectiveOffersTemplateByOfferIdResponses[keyof getAdageIframeCollectiveOffersTemplateByOfferIdResponses];

export type postAdageIframeCollectiveOffersTemplateByOfferIdRequestData = {
    body: PostCollectiveRequestBodyModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/adage-iframe/collective/offers-template/{offer_id}/request';
};

export type postAdageIframeCollectiveOffersTemplateByOfferIdRequestErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeCollectiveOffersTemplateByOfferIdRequestError = postAdageIframeCollectiveOffersTemplateByOfferIdRequestErrors[keyof postAdageIframeCollectiveOffersTemplateByOfferIdRequestErrors];

export type postAdageIframeCollectiveOffersTemplateByOfferIdRequestResponses = {
    /**
     * Created
     */
    201: CollectiveRequestResponseModel;
};

export type postAdageIframeCollectiveOffersTemplateByOfferIdRequestResponse = postAdageIframeCollectiveOffersTemplateByOfferIdRequestResponses[keyof postAdageIframeCollectiveOffersTemplateByOfferIdRequestResponses];

export type getAdageIframeCollectiveOffersMyInstitutionData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/collective/offers/my_institution';
};

export type getAdageIframeCollectiveOffersMyInstitutionErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeCollectiveOffersMyInstitutionError = getAdageIframeCollectiveOffersMyInstitutionErrors[keyof getAdageIframeCollectiveOffersMyInstitutionErrors];

export type getAdageIframeCollectiveOffersMyInstitutionResponses = {
    /**
     * OK
     */
    200: ListCollectiveOffersResponseModel;
};

export type getAdageIframeCollectiveOffersMyInstitutionResponse = getAdageIframeCollectiveOffersMyInstitutionResponses[keyof getAdageIframeCollectiveOffersMyInstitutionResponses];

export type getAdageIframeCollectiveOffersByOfferIdData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/adage-iframe/collective/offers/{offer_id}';
};

export type getAdageIframeCollectiveOffersByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeCollectiveOffersByOfferIdError = getAdageIframeCollectiveOffersByOfferIdErrors[keyof getAdageIframeCollectiveOffersByOfferIdErrors];

export type getAdageIframeCollectiveOffersByOfferIdResponses = {
    /**
     * OK
     */
    200: CollectiveOfferResponseModel;
};

export type getAdageIframeCollectiveOffersByOfferIdResponse = getAdageIframeCollectiveOffersByOfferIdResponses[keyof getAdageIframeCollectiveOffersByOfferIdResponses];

export type deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesData = {
    body?: never;
    path: {
        offer_template_id: number;
    };
    query?: never;
    url: '/adage-iframe/collective/template/{offer_template_id}/favorites';
};

export type deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesError = deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesErrors[keyof deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesErrors];

export type deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesResponse = deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesResponses[keyof deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesResponses];

export type postAdageIframeCollectiveTemplatesByOfferIdFavoritesData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/adage-iframe/collective/templates/{offer_id}/favorites';
};

export type postAdageIframeCollectiveTemplatesByOfferIdFavoritesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeCollectiveTemplatesByOfferIdFavoritesError = postAdageIframeCollectiveTemplatesByOfferIdFavoritesErrors[keyof postAdageIframeCollectiveTemplatesByOfferIdFavoritesErrors];

export type postAdageIframeCollectiveTemplatesByOfferIdFavoritesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeCollectiveTemplatesByOfferIdFavoritesResponse = postAdageIframeCollectiveTemplatesByOfferIdFavoritesResponses[keyof postAdageIframeCollectiveTemplatesByOfferIdFavoritesResponses];

export type postAdageIframeLogsBookingModalButtonData = {
    body: StockIdBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/booking-modal-button';
};

export type postAdageIframeLogsBookingModalButtonErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsBookingModalButtonError = postAdageIframeLogsBookingModalButtonErrors[keyof postAdageIframeLogsBookingModalButtonErrors];

export type postAdageIframeLogsBookingModalButtonResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsBookingModalButtonResponse = postAdageIframeLogsBookingModalButtonResponses[keyof postAdageIframeLogsBookingModalButtonResponses];

export type postAdageIframeLogsCatalogViewData = {
    body: CatalogViewBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/catalog-view';
};

export type postAdageIframeLogsCatalogViewErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsCatalogViewError = postAdageIframeLogsCatalogViewErrors[keyof postAdageIframeLogsCatalogViewErrors];

export type postAdageIframeLogsCatalogViewResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsCatalogViewResponse = postAdageIframeLogsCatalogViewResponses[keyof postAdageIframeLogsCatalogViewResponses];

export type postAdageIframeLogsConsultOfferData = {
    body: ConsultOfferBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/consult-offer';
};

export type postAdageIframeLogsConsultOfferErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsConsultOfferError = postAdageIframeLogsConsultOfferErrors[keyof postAdageIframeLogsConsultOfferErrors];

export type postAdageIframeLogsConsultOfferResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsConsultOfferResponse = postAdageIframeLogsConsultOfferResponses[keyof postAdageIframeLogsConsultOfferResponses];

export type postAdageIframeLogsConsultPlaylistElementData = {
    body: PlaylistBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/consult-playlist-element';
};

export type postAdageIframeLogsConsultPlaylistElementErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsConsultPlaylistElementError = postAdageIframeLogsConsultPlaylistElementErrors[keyof postAdageIframeLogsConsultPlaylistElementErrors];

export type postAdageIframeLogsConsultPlaylistElementResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsConsultPlaylistElementResponse = postAdageIframeLogsConsultPlaylistElementResponses[keyof postAdageIframeLogsConsultPlaylistElementResponses];

export type postAdageIframeLogsContactModalButtonData = {
    body: OfferBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/contact-modal-button';
};

export type postAdageIframeLogsContactModalButtonErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsContactModalButtonError = postAdageIframeLogsContactModalButtonErrors[keyof postAdageIframeLogsContactModalButtonErrors];

export type postAdageIframeLogsContactModalButtonResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsContactModalButtonResponse = postAdageIframeLogsContactModalButtonResponses[keyof postAdageIframeLogsContactModalButtonResponses];

export type postAdageIframeLogsContactUrlClickData = {
    body: OfferIdBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/contact-url-click';
};

export type postAdageIframeLogsContactUrlClickErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsContactUrlClickError = postAdageIframeLogsContactUrlClickErrors[keyof postAdageIframeLogsContactUrlClickErrors];

export type postAdageIframeLogsContactUrlClickResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsContactUrlClickResponse = postAdageIframeLogsContactUrlClickResponses[keyof postAdageIframeLogsContactUrlClickResponses];

export type postAdageIframeLogsFavOfferData = {
    body: OfferFavoriteBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/fav-offer/';
};

export type postAdageIframeLogsFavOfferErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsFavOfferError = postAdageIframeLogsFavOfferErrors[keyof postAdageIframeLogsFavOfferErrors];

export type postAdageIframeLogsFavOfferResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsFavOfferResponse = postAdageIframeLogsFavOfferResponses[keyof postAdageIframeLogsFavOfferResponses];

export type postAdageIframeLogsHasSeenWholePlaylistData = {
    body: PlaylistBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/has-seen-whole-playlist/';
};

export type postAdageIframeLogsHasSeenWholePlaylistErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsHasSeenWholePlaylistError = postAdageIframeLogsHasSeenWholePlaylistErrors[keyof postAdageIframeLogsHasSeenWholePlaylistErrors];

export type postAdageIframeLogsHasSeenWholePlaylistResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsHasSeenWholePlaylistResponse = postAdageIframeLogsHasSeenWholePlaylistResponses[keyof postAdageIframeLogsHasSeenWholePlaylistResponses];

export type postAdageIframeLogsHeaderLinkClickData = {
    body: AdageHeaderLogBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/header-link-click/';
};

export type postAdageIframeLogsHeaderLinkClickErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsHeaderLinkClickError = postAdageIframeLogsHeaderLinkClickErrors[keyof postAdageIframeLogsHeaderLinkClickErrors];

export type postAdageIframeLogsHeaderLinkClickResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsHeaderLinkClickResponse = postAdageIframeLogsHeaderLinkClickResponses[keyof postAdageIframeLogsHeaderLinkClickResponses];

export type postAdageIframeLogsOfferDetailData = {
    body: StockIdBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/offer-detail';
};

export type postAdageIframeLogsOfferDetailErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsOfferDetailError = postAdageIframeLogsOfferDetailErrors[keyof postAdageIframeLogsOfferDetailErrors];

export type postAdageIframeLogsOfferDetailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsOfferDetailResponse = postAdageIframeLogsOfferDetailResponses[keyof postAdageIframeLogsOfferDetailResponses];

export type postAdageIframeLogsOfferListViewSwitchData = {
    body: OfferListSwitch;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/offer-list-view-switch';
};

export type postAdageIframeLogsOfferListViewSwitchErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsOfferListViewSwitchError = postAdageIframeLogsOfferListViewSwitchErrors[keyof postAdageIframeLogsOfferListViewSwitchErrors];

export type postAdageIframeLogsOfferListViewSwitchResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsOfferListViewSwitchResponse = postAdageIframeLogsOfferListViewSwitchResponses[keyof postAdageIframeLogsOfferListViewSwitchResponses];

export type postAdageIframeLogsOfferTemplateDetailData = {
    body: OfferIdBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/offer-template-detail';
};

export type postAdageIframeLogsOfferTemplateDetailErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsOfferTemplateDetailError = postAdageIframeLogsOfferTemplateDetailErrors[keyof postAdageIframeLogsOfferTemplateDetailErrors];

export type postAdageIframeLogsOfferTemplateDetailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsOfferTemplateDetailResponse = postAdageIframeLogsOfferTemplateDetailResponses[keyof postAdageIframeLogsOfferTemplateDetailResponses];

export type postAdageIframeLogsPlaylistData = {
    body: AdageBaseModel;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/playlist';
};

export type postAdageIframeLogsPlaylistErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsPlaylistError = postAdageIframeLogsPlaylistErrors[keyof postAdageIframeLogsPlaylistErrors];

export type postAdageIframeLogsPlaylistResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsPlaylistResponse = postAdageIframeLogsPlaylistResponses[keyof postAdageIframeLogsPlaylistResponses];

export type postAdageIframeLogsRequestPopinDismissData = {
    body: CollectiveRequestBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/request-popin-dismiss';
};

export type postAdageIframeLogsRequestPopinDismissErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsRequestPopinDismissError = postAdageIframeLogsRequestPopinDismissErrors[keyof postAdageIframeLogsRequestPopinDismissErrors];

export type postAdageIframeLogsRequestPopinDismissResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsRequestPopinDismissResponse = postAdageIframeLogsRequestPopinDismissResponses[keyof postAdageIframeLogsRequestPopinDismissResponses];

export type postAdageIframeLogsSatSurveyData = {
    body: AdageBaseModel;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/sat-survey';
};

export type postAdageIframeLogsSatSurveyErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsSatSurveyError = postAdageIframeLogsSatSurveyErrors[keyof postAdageIframeLogsSatSurveyErrors];

export type postAdageIframeLogsSatSurveyResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsSatSurveyResponse = postAdageIframeLogsSatSurveyResponses[keyof postAdageIframeLogsSatSurveyResponses];

export type postAdageIframeLogsSearchButtonData = {
    body: SearchBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/search-button';
};

export type postAdageIframeLogsSearchButtonErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsSearchButtonError = postAdageIframeLogsSearchButtonErrors[keyof postAdageIframeLogsSearchButtonErrors];

export type postAdageIframeLogsSearchButtonResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsSearchButtonResponse = postAdageIframeLogsSearchButtonResponses[keyof postAdageIframeLogsSearchButtonResponses];

export type postAdageIframeLogsSearchShowMoreData = {
    body: TrackingShowMoreBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/search-show-more';
};

export type postAdageIframeLogsSearchShowMoreErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsSearchShowMoreError = postAdageIframeLogsSearchShowMoreErrors[keyof postAdageIframeLogsSearchShowMoreErrors];

export type postAdageIframeLogsSearchShowMoreResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsSearchShowMoreResponse = postAdageIframeLogsSearchShowMoreResponses[keyof postAdageIframeLogsSearchShowMoreResponses];

export type postAdageIframeLogsTrackingAutocompletionData = {
    body: TrackingAutocompleteSuggestionBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/tracking-autocompletion';
};

export type postAdageIframeLogsTrackingAutocompletionErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsTrackingAutocompletionError = postAdageIframeLogsTrackingAutocompletionErrors[keyof postAdageIframeLogsTrackingAutocompletionErrors];

export type postAdageIframeLogsTrackingAutocompletionResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsTrackingAutocompletionResponse = postAdageIframeLogsTrackingAutocompletionResponses[keyof postAdageIframeLogsTrackingAutocompletionResponses];

export type postAdageIframeLogsTrackingCtaShareData = {
    body: TrackingCTAShareBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/tracking-cta-share';
};

export type postAdageIframeLogsTrackingCtaShareErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsTrackingCtaShareError = postAdageIframeLogsTrackingCtaShareErrors[keyof postAdageIframeLogsTrackingCtaShareErrors];

export type postAdageIframeLogsTrackingCtaShareResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsTrackingCtaShareResponse = postAdageIframeLogsTrackingCtaShareResponses[keyof postAdageIframeLogsTrackingCtaShareResponses];

export type postAdageIframeLogsTrackingFilterData = {
    body: TrackingFilterBody;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/tracking-filter';
};

export type postAdageIframeLogsTrackingFilterErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsTrackingFilterError = postAdageIframeLogsTrackingFilterErrors[keyof postAdageIframeLogsTrackingFilterErrors];

export type postAdageIframeLogsTrackingFilterResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsTrackingFilterResponse = postAdageIframeLogsTrackingFilterResponses[keyof postAdageIframeLogsTrackingFilterResponses];

export type postAdageIframeLogsTrackingMapData = {
    body: AdageBaseModel;
    path?: never;
    query?: never;
    url: '/adage-iframe/logs/tracking-map';
};

export type postAdageIframeLogsTrackingMapErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeLogsTrackingMapError = postAdageIframeLogsTrackingMapErrors[keyof postAdageIframeLogsTrackingMapErrors];

export type postAdageIframeLogsTrackingMapResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeLogsTrackingMapResponse = postAdageIframeLogsTrackingMapResponses[keyof postAdageIframeLogsTrackingMapResponses];

export type getAdageIframePlaylistsClassroomData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/playlists/classroom';
};

export type getAdageIframePlaylistsClassroomErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframePlaylistsClassroomError = getAdageIframePlaylistsClassroomErrors[keyof getAdageIframePlaylistsClassroomErrors];

export type getAdageIframePlaylistsClassroomResponses = {
    /**
     * OK
     */
    200: ListCollectiveOfferTemplateResponseModel;
};

export type getAdageIframePlaylistsClassroomResponse = getAdageIframePlaylistsClassroomResponses[keyof getAdageIframePlaylistsClassroomResponses];

export type getAdageIframePlaylistsLocalOfferersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/playlists/local-offerers';
};

export type getAdageIframePlaylistsLocalOfferersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframePlaylistsLocalOfferersError = getAdageIframePlaylistsLocalOfferersErrors[keyof getAdageIframePlaylistsLocalOfferersErrors];

export type getAdageIframePlaylistsLocalOfferersResponses = {
    /**
     * OK
     */
    200: LocalOfferersPlaylist;
};

export type getAdageIframePlaylistsLocalOfferersResponse = getAdageIframePlaylistsLocalOfferersResponses[keyof getAdageIframePlaylistsLocalOfferersResponses];

export type getAdageIframePlaylistsNewOfferersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/playlists/new_offerers';
};

export type getAdageIframePlaylistsNewOfferersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframePlaylistsNewOfferersError = getAdageIframePlaylistsNewOfferersErrors[keyof getAdageIframePlaylistsNewOfferersErrors];

export type getAdageIframePlaylistsNewOfferersResponses = {
    /**
     * OK
     */
    200: LocalOfferersPlaylist;
};

export type getAdageIframePlaylistsNewOfferersResponse = getAdageIframePlaylistsNewOfferersResponses[keyof getAdageIframePlaylistsNewOfferersResponses];

export type getAdageIframePlaylistsNewTemplateOffersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/playlists/new_template_offers';
};

export type getAdageIframePlaylistsNewTemplateOffersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframePlaylistsNewTemplateOffersError = getAdageIframePlaylistsNewTemplateOffersErrors[keyof getAdageIframePlaylistsNewTemplateOffersErrors];

export type getAdageIframePlaylistsNewTemplateOffersResponses = {
    /**
     * OK
     */
    200: ListCollectiveOfferTemplateResponseModel;
};

export type getAdageIframePlaylistsNewTemplateOffersResponse = getAdageIframePlaylistsNewTemplateOffersResponses[keyof getAdageIframePlaylistsNewTemplateOffersResponses];

export type postAdageIframeRedactorPreferencesData = {
    body: RedactorPreferences;
    path?: never;
    query?: never;
    url: '/adage-iframe/redactor/preferences';
};

export type postAdageIframeRedactorPreferencesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postAdageIframeRedactorPreferencesError = postAdageIframeRedactorPreferencesErrors[keyof postAdageIframeRedactorPreferencesErrors];

export type postAdageIframeRedactorPreferencesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postAdageIframeRedactorPreferencesResponse = postAdageIframeRedactorPreferencesResponses[keyof postAdageIframeRedactorPreferencesResponses];

export type getAdageIframeTestingTokenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/adage-iframe/testing/token';
};

export type getAdageIframeTestingTokenErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeTestingTokenError = getAdageIframeTestingTokenErrors[keyof getAdageIframeTestingTokenErrors];

export type getAdageIframeTestingTokenResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type getAdageIframeVenuesSiretBySiretData = {
    body?: never;
    path: {
        siret: string;
    };
    query?: {
        /**
         * Getrelative
         */
        getRelative?: boolean;
    };
    url: '/adage-iframe/venues/siret/{siret}';
};

export type getAdageIframeVenuesSiretBySiretErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeVenuesSiretBySiretError = getAdageIframeVenuesSiretBySiretErrors[keyof getAdageIframeVenuesSiretBySiretErrors];

export type getAdageIframeVenuesSiretBySiretResponses = {
    /**
     * OK
     */
    200: VenueResponse;
};

export type getAdageIframeVenuesSiretBySiretResponse = getAdageIframeVenuesSiretBySiretResponses[keyof getAdageIframeVenuesSiretBySiretResponses];

export type getAdageIframeVenuesByVenueIdData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: {
        /**
         * Getrelative
         */
        getRelative?: boolean;
    };
    url: '/adage-iframe/venues/{venue_id}';
};

export type getAdageIframeVenuesByVenueIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getAdageIframeVenuesByVenueIdError = getAdageIframeVenuesByVenueIdErrors[keyof getAdageIframeVenuesByVenueIdErrors];

export type getAdageIframeVenuesByVenueIdResponses = {
    /**
     * OK
     */
    200: VenueResponse;
};

export type getAdageIframeVenuesByVenueIdResponse = getAdageIframeVenuesByVenueIdResponses[keyof getAdageIframeVenuesByVenueIdResponses];
